import React from 'react';
import StylingMockLayout from '../shared/StylingMockLayout';
import Logo from 'components/Logo';
import HeroSection from 'components/container/HeroSection';
import './StylingMockLogo.css';

/**
 * Styling Mock Logo Page
 * Showcases logo variations, sizes, and usage in containers
 */
const StylingMockLogo = () => {

  return (
    <StylingMockLayout>
      <div className="styling-mock-logo">
        <div className="styling-mock-section">
          <h2 className="styling-mock-section-title">Logo Variations</h2>
          <p className="styling-mock-section-description">
            Discover logo variations, sizes, light/dark mode versions, and usage examples in different containers.
          </p>
        </div>

        {/* Logo Sizes */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Logo Sizes</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <div className="styling-mock-logo-showcase-item">
                <h4>Small</h4>
                <Logo size="small" />
              </div>
              <div className="styling-mock-logo-showcase-item">
                <h4>Default</h4>
                <Logo size="default" />
              </div>
              <div className="styling-mock-logo-showcase-item">
                <h4>Large</h4>
                <Logo size="large" />
              </div>
            </div>
            <div className="styling-mock-code-block">
{`<Logo size="small" />
<Logo size="default" />
<Logo size="large" />`}
            </div>
          </div>
        </div>

        {/* Logo Variations */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Logo Variations</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <div className="styling-mock-logo-showcase-item">
                <h4>With Tagline</h4>
                <Logo showTagline={true} />
              </div>
              <div className="styling-mock-logo-showcase-item">
                <h4>Without Tagline</h4>
                <Logo showTagline={false} />
              </div>
              <div className="styling-mock-logo-showcase-item">
                <h4>With Vertical Line</h4>
                <Logo showVerticalLine={true} />
              </div>
              <div className="styling-mock-logo-showcase-item">
                <h4>Without Vertical Line</h4>
                <Logo showVerticalLine={false} />
              </div>
            </div>
            <div className="styling-mock-code-block">
{`<Logo showTagline={true} />
<Logo showTagline={false} />
<Logo showVerticalLine={true} />
<Logo showVerticalLine={false} />`}
            </div>
          </div>
        </div>

        {/* Logo in Containers */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Logo Usage in Containers</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <div className="styling-mock-logo-container-example">
                <h4>Logo in HeroSection</h4>
                <HeroSection
                  title="Hero Section with Logo"
                  subtitle="This demonstrates logo usage in a hero section"
                  buttonText="Get Started"
                  onButtonClick={() => alert('Button clicked!')}
                  visual={<Logo size="default" />}
                />
              </div>
            </div>
            <div className="styling-mock-code-block">
{`<HeroSection
  title="Hero Section with Logo"
  subtitle="This demonstrates logo usage in a hero section"
  buttonText="Get Started"
  onButtonClick={() => {}}
  visual={<Logo size="default" />}
/>`}
            </div>
          </div>
        </div>

        {/* Light/Dark Mode Examples */}
        <div className="styling-mock-section">
          <h3 className="styling-mock-section-title">Light/Dark Mode</h3>
          <div className="styling-mock-showcase">
            <div className="styling-mock-showcase-content">
              <div className="styling-mock-logo-showcase-item">
                <h4>Light Mode</h4>
                <div className="styling-mock-logo-light-mode">
                  <Logo size="default" />
                </div>
              </div>
              <div className="styling-mock-logo-showcase-item">
                <h4>Dark Mode</h4>
                <div className="styling-mock-logo-dark-mode">
                  <Logo size="default" />
                </div>
              </div>
            </div>
            <div className="styling-mock-code-block">
{`<Logo size="default" />
<!-- Logo automatically adapts to theme -->`}
            </div>
          </div>
        </div>
      </div>
    </StylingMockLayout>
  );
};

export default StylingMockLogo;

